import { Spin } from 'antd';

import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { InputPassword } from '@atom/form/input/input';
import { Label } from '@atom/form/label/label';
import { Form } from '@form/common.style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';

import { initialResetPassword } from './new-password.form-initial';
import { newPasswordFormValidation, passwordConfirmationValidation } from './new-password.form-validation';

export const NewPasswordForm = ({ error, isLoading = false, form }: BaseFormInterface) => (
  <Form form={form} initialValues={initialResetPassword} layout='vertical' name='new'>
    <Label label='New password' name='password' rules={[{ required: true }, newPasswordFormValidation]}>
      <InputPassword placeholder='Password' />
    </Label>
    <Label
      label='Repeat password'
      name='repeatPassword'
      rules={[{ required: true }, newPasswordFormValidation, passwordConfirmationValidation]}
    >
      <InputPassword placeholder='Repeat password' />
    </Label>
    <Form.Item>
      <Button htmlType='submit' type={ButtonTypeEnum.Primary} block>
        {isLoading && <Spin />}
        {!isLoading && 'RESET PASSWORD'}
      </Button>
    </Form.Item>
    <FormError error={error} errorField='password' />
  </Form>
);
